import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { useNavigate } from 'react-router-dom';

export const OUTDATED_STUDY_MESSAGE = 'This study uses our previous Fitbit system. You can still access the study, but you can no longer extract Fitbit data through the old system. StudySync has migrated to a new Fitbit system. Please create a new study and invite your participants to connect again.';

export default function OutdatedStudyNotice({ expanded = false, enrollmentsOnly = false, onCreate }: {
  expanded?: boolean; enrollmentsOnly?: boolean; onCreate?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return <Box onClick={event => event.stopPropagation()} sx={{ my: expanded ? 2 : 0 }}>
    <Button variant="outlined" color="warning" endIcon={<HelpOutline fontSize="small" />}
      aria-label={enrollmentsOnly ? 'Outdated Fitbit enrollments: learn more' : 'Outdated study: learn more'} onClick={() => setOpen(true)}
      sx={{ textTransform: 'none', borderRadius: 2, bgcolor: '#fff8ec', px: 1.5, py: .5, fontWeight: 600 }}>
      Outdated
    </Button>
    {expanded && <Typography color="text.secondary" variant="body2" sx={{ mt: 1 }}>
      {enrollmentsOnly ? 'Extraction is unavailable for these older Fitbit enrollments. Current Fitbit enrollments are unaffected.' :
        'Fitbit extraction is unavailable for this study. Create a new study to use the updated Fitbit system.'}
    </Typography>}
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" aria-labelledby="outdated-study-title">
      <DialogTitle id="outdated-study-title">{enrollmentsOnly ? 'These Fitbit enrollments are outdated' : 'This study is outdated'}</DialogTitle>
      <DialogContent><Typography sx={{ lineHeight: 1.8 }}>{enrollmentsOnly ?
        'These participants use our previous Fitbit system and can no longer use its data extraction. Create a new study and invite them to connect through the updated Fitbit system. You can continue extracting data for this study’s current Fitbit enrollments.' : OUTDATED_STUDY_MESSAGE}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>Your study details remain accessible. HealthKit is unaffected.</Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={() => setOpen(false)}>Close</Button>
        <Button variant="contained" onClick={() => { setOpen(false); if (onCreate) onCreate(); else navigate('/researcher/dashboard', { state: { createStudy: true } }); }}>Create a new study</Button>
      </DialogActions>
    </Dialog>
  </Box>;
}
